import {
    ComponentStoreV2Factory,
} from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';

@Injectable()
export class FolderOperationalReportPageStore extends ComponentStoreV2Factory {

    public operationalSettings = computed(() => {
        const data = this.data.getServiceSettings()?.['items']?.[0];

        return data?.data ? JSON.parse(data.data) : {};
    });

}
